import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = L.divIcon({
  className: "",
  html:
    '<div style="width:26px;height:26px;background:#4F46E5;border:2px solid #0F172A;border-radius:50% 50% 50% 0;transform:rotate(-45deg);box-shadow:2px 2px 0 0 #0F172A;"></div>',
  iconSize: [26, 26],
  iconAnchor: [13, 26],
});

export const VehicleMap = ({ lat, lng, label }) => {
  const ref = useRef(null);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  useEffect(() => {
    if (!ref.current || lat == null || lng == null || isNaN(lat) || isNaN(lng)) return;
    if (!mapRef.current) {
      mapRef.current = L.map(ref.current, { scrollWheelZoom: false }).setView([lat, lng], 13);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "© OpenStreetMap",
        maxZoom: 19,
      }).addTo(mapRef.current);
    } else {
      mapRef.current.setView([lat, lng], 13);
    }
    if (markerRef.current) markerRef.current.remove();
    markerRef.current = L.marker([lat, lng], { icon: pinIcon }).addTo(mapRef.current);
    if (label) markerRef.current.bindPopup(label);
    setTimeout(() => mapRef.current && mapRef.current.invalidateSize(), 200);
  }, [lat, lng, label]);

  useEffect(() => {
    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="vehicle-map"
      style={{ height: 280, zIndex: 0 }}
      className="rounded-xl border-2 border-slate-900 overflow-hidden nb-shadow"
    />
  );
};
